import { get, post } from '@/utils/request'
const loginApi = {
  /* 用户登录初始化(获取是否需要验证码等信息[1:需要 0:不需要]) */
  loginInit: function () {
    return get('passport/login-init', {})
  },
  /* 发送登录验证码 */
  getLoginCode: function (username) {
    return post('passport/login/send-code', {
      username: username
    })
  },
  /* 用户登录 */
  userLogin: function (params) {
    return post('passport/login', {
      username: params.username,
      password: params.password,
      code: params.code,
      sessionId: params.sessionId,
      token: params.token,
      scene: params.scene,
      sig: params.sig
    })
  },
  /* 用户注销登录 */
  loginOut: function () {
    return post('passport/logout', {})
  }
}

export default loginApi



// WEBPACK FOOTER //
// ./src/api/login.js